<template>
  <OffSetDefault id="offset-graficas" title="Graficas" size="lg">
        <template #body>
          <div class="p-4">
            <Graficas :persona="persona" :technologias="technologias" />
          </div>
        </template>
  </OffSetDefault>
</template>
<script setup lang="ts">
import Graficas from '@/modules/Asistencial/components/PatientGraficas.vue'
import type { IConfPersonasPaciente } from '@/modules/Administracion/interfaces'
import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'

defineProps<{
  persona: IConfPersonasPaciente
  technologias?: ICitaTechnologiasSalud[]
}>()
</script>
